
import { Component, Vue, Watch } from "vue-property-decorator";
import api from "@/network/api";
import { AxiosResponse } from "axios";
import Unity from "vue-unity-webgl";
import { Route } from "vue-router";
import { Language } from "../../models/Language";
import { Getter } from "vuex-class";
import ILPUnity from "../../components/ui/ILPUnity.vue";

@Component({
  components: {
    Unity,
    ILPUnity
  }
})
export default class TrainingRoomPage extends Vue {
  private lesson: any = {};

  @Getter('userLanguageId') private currentLanguage!: Language;
  private isInteractive = false;
  private lessonReady = false;
  private lessonComplete = false;
  private player: any;
  private supposedCurrentTime = 0;
  private visibilityPause = false;
  maxChars = 300;
  showMore = true;
  async finishWatching() {
    const tokenRes: AxiosResponse<{ token: string }> = await this.getSubmissionToken();
    console.log(tokenRes);

    api
      .post("taken_lessons", {
        lesson: this.lesson.id,
        token: tokenRes.data.token,
      })
      .then((res: AxiosResponse) => {
        this.lessonComplete = true;
      });
  }

  created() {
    const lessonParam = this.$route.query.lesson;
    this.isInteractive = this.$route.name === "Interactive Lesson Room";
    if(this.isInteractive) {
      api.get("lessons/" + lessonParam).then((res: AxiosResponse) => {
        this.lesson = res.data.lesson;
        this.lessonComplete = this.lesson.taken;
        this.lessonReady = true;
        this.registerWindowFunction();
      });
      return;
    }
    api.get("lessons/" + lessonParam).then((res: AxiosResponse) => {
      this.lesson = res.data.lesson;
      this.lessonComplete = this.lesson.taken;
      this.triggerPlayEvents();
    });

    this.registerVisibilityEvent();
  }

  registerWindowFunction() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    window.communicateWithWeb = async (json: string, callback: CallableFunction) => {
        const data = JSON.parse(json);
        const type = data.type.trim();
        let temp = {};
        const filePath = '/interactive-lessons-data/' + this.lesson.code + '/StreamingAssets/' + this.currentLanguage.code;
        switch(type) {
          case "getLanguage": {
            temp = {
              type : data.type,
              data: {
                language : this.currentLanguage.name
              }
            };
            break;
          }
          case "getLessonVideoData": {
            const response = await fetch(`${filePath}/LessonJSON.json`);
            const lessonData = await response.json();
            console.log(lessonData);
            temp = {
              type : data.type,
              data: lessonData
            };
            break;
          }
          case "getLessonStyle": {
            const response = await fetch(`${filePath}/StyleData.json`);
            const styleData = await response.json();
            temp = {
              type : data.type,
              data: styleData
            };
            break;
          }
          case "getVideoSettings": {
            const response = await fetch(filePath+"/VideoSettings.json");
            const videoSettings = await response.json();
            temp = {
              type : data.type,
              data: videoSettings
            };
            break;
          }
          case "getVideoURL": {
            const response = await fetch(`${filePath}/videoURL.json`);
            const videoURL = await response.json();
            temp = {
              type : data.type,
              data: videoURL
            };
            break;
          }
          case "lessonWatched": {
            this.supposedCurrentTime = 0;
            this.lesson.taken = true;
            this.finishWatching();
            break;
          }
        }
        callback(JSON.stringify(temp));
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    window.getUnityInstance = () => {
      return (this.$refs.unityContainer as any).gameInstance;
    };
  }

  @Watch("$route")
  ifLessonIdChanges(route: Route) {
    if (route.query.lesson !== this.lesson.id) {
      location.reload();
    }
  }

  triggerPlayEvents() {
    this.$nextTick(function () {
      this.player = this.$refs.videoPlayer as any;
      if (this.player) {
        this.player.play();

        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;

        this.player.addEventListener("play", function () {
          //? Disables session during playback.
          self.$store.dispatch("setPlayingVideoState", true);
        });

        this.player.addEventListener("pause", function () {
          self.$store.dispatch("setPlayingVideoState", false);
        });

        // disable seeking
        this.player.addEventListener("timeupdate", function () {
          if (self.player && !self.player.seeking) {
            self.supposedCurrentTime = self.player.currentTime;
          }
        });

        // on seeking
        this.player.addEventListener("seeking", function () {
          const delta = self.player.currentTime - self.supposedCurrentTime;
          if (Math.abs(delta) > 0.01) {
            self.player.currentTime = self.supposedCurrentTime;
          }
        });

        //re-play
        this.player.addEventListener("ended", function () {
          self.supposedCurrentTime = 0;
          self.lesson.taken = true;
          self.finishWatching();
        });
      }
    });
  }

  watchAgain() {
    const lessonParam = this.$route.query.lesson;
    api.get("lessons/" + lessonParam).then((res: AxiosResponse) => {
      this.lesson = res.data.lesson;
      this.lessonComplete = false;
      this.triggerPlayEvents();
      this.supposedCurrentTime = 0;
      if (this.player) {
        this.player.removeAttribute("src");
        this.player.load();
      }
    });
  }

  gotoQuiz() {
    let quizPath = this.$route.path.replace("training_room", "quiz");
    quizPath = quizPath.replace("interactive_lesson", "quiz");
    this.$router.push(quizPath + "?lesson=" + this.$route.query.lesson);
  }

  registerVisibilityEvent() {
    document.addEventListener("visibilitychange", this.visibilityHandler);
  }
  visibilityHandler() {
    if (this.player) {
      if (document.visibilityState === "visible" && this.visibilityPause) {
        this.player.play();
        this.visibilityPause = false;
      } else {
        if (!this.player.paused) {
          this.player.pause();
          this.visibilityPause = true;
        }
      }
    }
  }
  gohome() {
    this.$router.push("/");
  }

  beforeCreate(){
      if (this.isInteractive) {
        try {
          delete (window as any).unityInstance;
        } catch (ex) {
          console.debug(ex);
        }
      }
  }

  beforeDestroy() {
    this.$destroy;
    if (this.isInteractive) {
        try{
            const gameInstance = (this.$refs.unityContainer as any).getGameInstance();
            if (gameInstance !== null) {
                gameInstance.Quit();
            }
        } catch(err) {
            console.log('termination error', err);
        }
    } else {
        document.removeEventListener("visibilitychange", this.visibilityHandler);
        this.player = null;
    }
  }

  getSubmissionToken() {
    return api.get(`lessons/${this.lesson.id}/submission_token`);
  }
}
